module.exports = __webpack_public_path__ + "static/media/genie.16b0a475.png";